//I18n
import Translate from '../../i18n/Translate'

//Intersection
import { useInView } from 'react-intersection-observer'

//Images
import icon1 from '../../assets/images/about/icon1.svg'
import icon2 from '../../assets/images/about/icon2.svg'
import icon3 from '../../assets/images/about/icon3.svg'
import icon4 from '../../assets/images/about/icon4.svg'
import icon5 from '../../assets/images/about/icon5-new.svg'

const WhyUs = () => {
    const [container, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    return (
        <section className="incoming-about__why-us">
            <h2 className="title">
                <Translate langkey="about.why_us.title" />
            </h2>

            <p className="copy">
                <Translate langkey="about.why_us.copy" />
            </p>

            <div className={`container animate slide-up ${inView ? 'in-view' : ''}`} ref={container}>
                <div className="item">
                    <img src={icon1} alt="icon" />
                    <h3>
                        <Translate langkey="about.why_us.calidad.title" />
                    </h3>
                    <p>
                        <Translate langkey="about.why_us.calidad.copy" />
                    </p>
                </div>
                <div className="item">
                    <img src={icon2} alt="icon" />
                    <h3>
                        <Translate langkey="about.why_us.atencion.title" />
                    </h3>
                    <p>
                        <Translate langkey="about.why_us.atencion.copy" />
                    </p>
                </div>
                <div className="item">
                    <img src={icon3} alt="icon" />
                    <h3>
                        <Translate langkey="about.why_us.personalizacion.title" />
                    </h3>
                    <p>
                        <Translate langkey="about.why_us.personalizacion.copy" />
                    </p>
                </div>
                <div className="item">
                    <img src={icon4} alt="icon" />
                    <h3>
                        <Translate langkey="about.why_us.soluciones.title" />
                    </h3>
                    <p>
                        <Translate langkey="about.why_us.soluciones.copy" />
                    </p>
                </div>
                <div className="item">
                    <img src={icon5} alt="icon" />
                    <h3>
                        <Translate langkey="about.why_us.agilidad.title" />
                    </h3>
                    <p>
                        <Translate langkey="about.why_us.agilidad.copy" />
                    </p>
                </div>
            </div>
        </section>
    )
}

export default WhyUs
